export enum FIELD_TYPE {
    STRING = 'string',
    NUMBER = 'number',
    ENUM = 'enum',
    MULTI_OPTIONS= 'multi-options'
}

export enum ENUM_FIELD_OPERATORS {
    IN = 'is',
    NOT_IN = 'is not',
}

export enum MULTI_OPTIONS_OPERATORS {
    IN = 'in',
    NOT_IN = 'not in'
}

export enum NUMBER_FIELD_OPERATORS {
    EQUAL = 'equal',
    NOT_EQUAL = 'not_equal',
    LESS_THAN = 'less_than',
    GREATER_THAN = 'greater_than',
    LESS_OR_EQUAL_TO = 'less_or_equal_to',
    GREATER_OR_EQUAL_TO = 'greater_or_equal_to',
}

export enum STRING_FIELD_OPERATORS {
    EQUAL = 'equal',
    NOT_EQUAL = 'not_equal',
    INCLUDES = 'includes',
    NOT_INCLUDES = 'not_includes',
}

export enum STATUS_OPTIONS {
    ACTIVE = 'active',
    PAUSED = 'paused',
}
